





















































import TakeAway from '@/models/takeAway';
import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import CodeForm from './components/CodeForm.vue';
import PhoneForm from './components/PhoneForm.vue';
import PopupWrapper from '@/components/ui/PopupWrapper/AuthWrapper.vue';
import { sameAs, maxLength, minLength, numeric, required } from 'vuelidate/lib/validators';
import name from '@/validators/rules/name';
import phone from '@/validators/rules/phone';
import userService from '@/api/services/user.service';
import BaseAsyncButton from '@/components/base/BaseAsyncButton.vue';
import {Action, State} from 'vuex-class';
import {ActionMethod} from 'vuex';

@Component({
  name: 'RegisterPopup',
  components: {
    BaseAsyncButton,
    PopupWrapper,
    CodeForm,
    PhoneForm,
  },
  validations: {
    client: {
      name: {
        required,
        name,
      },
      phone: {
        required,
        phone,
      },
    },
    isAgreeWithTermOfUseOfTheService: {
      sameAs: sameAs(
        () => true
      )
    },
    code: {
      minLength: minLength(5),
      maxLength: maxLength(5),
      required,
      numeric,
    },
  },
})
export default class RegisterPopup extends Vue {
  @Prop({
    type: Boolean,
    default: false,
  })
  private withoutRedirect!: boolean;

  @Prop({
    type: String,
    required: true,
  })
  private currentPhone!: string;

  private client: { name: string, phone: string } = {
    name: '',
    phone: this.currentPhone,
  };
  private code: string = '';
  private isPhoneCodeSent: boolean = false;
  private hasError: boolean = false;
  private isAgreeWithTermOfUseOfTheService: boolean = false;

  @State('projectId')
  projectId!: string;

  @State('orders', {
    namespace: 'orderHistory',
  })
  orders!: TakeAway[];

  @Watch('phone')
  private onPhoneChanged() {
    this.hasError = false;
  }

  private async register() {
    this.$v.client.$touch();

    const phoneForm: any = <any> this.$refs.phoneForm;
    phoneForm.$v.$touch();

    if (!this.$v.client.$invalid && this.isAgreeWithTermOfUseOfTheService) {
      try {
        await userService.registerByPhone({
          client: this.client,
          projectId: this.projectId,
        });

        this.isPhoneCodeSent = true;
      } catch (e) {
        this.hasError = true;
      }
    }
  }

  private async login() {
    this.$v.$touch();

    if (!this.$v.$invalid) {
      try {
        await this.loginAction({
          phone: this.client.phone,
          projectId: this.projectId,
          code: this.code,
        });

        if (this.withoutRedirect) {
          this.close();

          return;
        }

        if (this.orders.length > 0) {
          this.$router.push({
            name: 'orderHistory',
            params: {
              projectId: this.$route.params.projectId,
            }
          });
        } else if (this.$route.name !== 'takeAwayMenu') {
          this.$router.push({
            name: 'takeAwayMenu',
            params: {
              projectId: this.$route.params.projectId,
              placeId: this.$route.params.placeId,
            }
          });
        }

        this.close();
      } catch (e) {
        this.code = '';
      }
    }
  }

  private changeAgree(isAgreeWithTermOfUseOfTheService: boolean) {
    this.isAgreeWithTermOfUseOfTheService = isAgreeWithTermOfUseOfTheService;
  }

  @Action('login', {
    namespace: 'user'
  })
  private loginAction!: ActionMethod;

  private close() {
    this.$emit('close');
    this.$destroy();
  }
}
